// Employee session context — completely separate from the owner AuthProvider.
// Reads only `/api/e/me` (cookie-authenticated). Never touches localStorage.
import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { employeeApi } from "./employeeApi";

const EmployeeAuthCtx = createContext(null);

export function EmployeeAuthProvider({ children }) {
    const [me, setMe] = useState(null);
    const [loading, setLoading] = useState(true);
    const [revoked, setRevoked] = useState(false);

    const refresh = useCallback(async () => {
        setLoading(true);
        const res = await employeeApi.me();
        if (res.ok && res.data) {
            setMe(res.data);
            setRevoked(false);
        } else if (res.status === 410) {
            setMe(null);
            setRevoked(true);
        } else {
            setMe(null);
            setRevoked(false);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const logout = useCallback(async () => {
        await employeeApi.logout();
        setMe(null);
    }, []);

    return (
        <EmployeeAuthCtx.Provider value={{ me, loading, revoked, refresh, logout }}>
            {children}
        </EmployeeAuthCtx.Provider>
    );
}

export function useEmployeeAuth() {
    const ctx = useContext(EmployeeAuthCtx);
    if (!ctx) throw new Error("useEmployeeAuth must be used inside <EmployeeAuthProvider>");
    return ctx;
}

export function RequireEmployee({ children }) {
    const { me, loading, revoked } = useEmployeeAuth();
    if (loading) return null;
    if (revoked) return <Navigate to="/e/revoked" replace />;
    if (!me) return <Navigate to="/e/revoked" replace />;
    return children;
}
